import { useEffect, useReducer } from "react"

import api from "../../api"
import { getSession } from "../../auth"
import defaultReducer from "../../utils/defaultReducer"

// Bootstraps a Cortex session for the logged-in agent, mirroring
// frontend/src/components/KwikAssistant/index.js's login() flow, minus the
// kwik-assistant <script> injection - these are native components now.
const useCortexSession = () => {
    const [state, setState] = useReducer(defaultReducer, {
        ready: false,
        enterpriseHasAssistant: false,
        userHasAssistant: false,
        accessToken: null,
        accountcode: null,
        userId: null,
        assistantUrl: null,
        streamMode: false,
    })

    useEffect(() => {
        let cancelled = false

        const login = async () => {
            const user = getSession()

            const enterpriseHasAssistant = !!user?.profile?.enterprise?.has_assistant
            const userHasAssistant = enterpriseHasAssistant && !!user?.profile?.has_assistant

            if (!userHasAssistant) {
                if (!cancelled)
                    setState({ ready: true, enterpriseHasAssistant, userHasAssistant })
                return
            }

            const agentId = user.profile.agent.id
            const res = await api.post(`/api/IV/agents/${agentId}/assistant_login/`)

            if (cancelled) return

            if (res.status === 200) {
                setState({
                    ready: true,
                    enterpriseHasAssistant,
                    userHasAssistant,
                    accessToken: res.data['access_token'],
                    accountcode: user.profile.enterprise.assistant_accountcode_id,
                    userId: user.profile.assistant_user_id,
                    assistantUrl: res.data['assistant_url'],
                    streamMode: !!user.profile.stream_mode,
                })
            } else {
                console.error('Couldnt login agent assistant [err:%o]', res.err)
                setState({ ready: true, enterpriseHasAssistant, userHasAssistant })
            }
        }

        login()

        return () => { cancelled = true }
    }, [])

    return state
}

export default useCortexSession
